import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { getDeepLinkType } from 'Store/user/selectors';

import deeplinkMessage from 'Containers/LoginPage/common/deeplinkMessage';

const useDeeplinkMessage = () => {
  const { formatMessage } = useIntl();
  const deeplinkOtpType = useSelector(getDeepLinkType);

  const intlId = deeplinkOtpType ? deeplinkMessage[deeplinkOtpType] : '';
  const message = intlId ? formatMessage({ id: intlId }) : undefined;

  return {
    message,
  };
};

export default useDeeplinkMessage;
